import { WorkflowProps } from './Types'
import { forwardRef } from 'react'
import { PropertyService } from 'api/services/PropertyService'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { IWorkflow } from 'stores/Workflows/Types'
import { useConfirmModal } from 'hooks/useConfirmModal'
import { DeleteWorkflowConfirmationModal } from 'components/DeleteWorkflowConfirmationModal/DeleteWorkflowConfirmationModal'
import { CreateForm } from './CreateForm/CreateForm'
import { UpdateForm } from './UpdateForm/UpdateForm'
import { observer } from 'mobx-react-lite'
import { useRefresh } from './useRefresh'

const Workflow = observer(
  forwardRef<any, WorkflowProps>(({ handbookKey, folder, onClose }, ref) => {
    const currentWorkspace = useCurrentWorkspace()
    const confirmDeletion = useConfirmModal(DeleteWorkflowConfirmationModal)
    const { refresh } = useRefresh({ folderKey: folder.key, handbookKey })

    const canUpdate = folder.has_edit_access
    const canDelete = canUpdate
    const canCreate = canUpdate

    if (!currentWorkspace || (!folder.workflow_id && !canCreate)) {
      return null
    }

    const deleteWorkflow = async (workflow: IWorkflow) => {
      const confirmed = await confirmDeletion()
      if (!confirmed) {
        return
      }
      await PropertyService.deleteProperty(currentWorkspace.key, workflow.property)
      refresh()
    }

    if (!folder.workflow_id) {
      return <CreateForm folderId={folder.key} onCreate={refresh} ref={ref} onClose={onClose} />
    }

    if (canUpdate) {
      return (
        <UpdateForm
          folderId={folder.key}
          onDelete={canDelete ? deleteWorkflow : undefined}
          ref={ref}
          onClose={onClose}
        />
      )
    }

    return null
  }),
)

export { Workflow }
